export default {
  name: 'CaseComponent',
  data: function () {
    return {
      header: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseComponent/CaseComponent.js